import API from "./index"

export const getHeroSlides = () => API.get(`/hero`)
export const createHeroSlide = (data) => API.post(`/hero`, data)
export const deleteHeroSlide = (id) => API.delete(`/hero/${id}`)